import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SidebarMenu from "components/layout/SidebarMenu";
import Topbar from "components/layout/Topbar";


function MainLayout({ children, ...restProps }) {
    return (
        <div style={{minHeight:'100%'}} {...restProps}>
            <Topbar />
            <SidebarMenu />
            <Container fluid className="wrapper">
                <Row>
                    <Col xs className="py-2" id="page-content-wrapper">
                        <Container fluid>{children}</Container>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default MainLayout;
